import type { IconData } from '../../types';

export const data: IconData = {
  o: '<mask id="a" width="23" height="23" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h23v23H0z"/></mask><g fill="#43474E" mask="url(#a)"><path d="M10 4h1l1 1-1 1H5v12h12l-2 2H3V4h7ZM19 11l1 1v3l-2 2v-5l1-1ZM17 3l2 1 1 2-1 2-2 1-2-1-1-2 1-2 2-1Z"/><path d="m13 15 1-1h6v1l-5 5h-2v-5Z"/></g>',
  f: '<mask id="a" width="23" height="23" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h23v23H0z"/></mask><g fill="#43474E" mask="url(#a)"><path d="M10 4h1l1 1-1 1H5v12h12l-2 2H3V4h7ZM19 11l1 1v3l-2 2v-5l1-1ZM17 3l2 1 1 2-1 2-2 1-2-1-1-2 1-2 2-1Z"/><path d="m13 15 1-1h6v1l-5 5h-2v-5Z"/></g>',
  vb: '0 0 23 23',
  rao: { fill: 'none' },
  raf: { fill: 'none' },
};

export default data;
